const SCHEDULE_ORDER_SAMPLE_DATA = {
  contentData: {
    scheduleOrderHeaderText: 'scheduleOrder',
    changeScheduleOrderHeaderText: 'changeYourOrderTitle',
    scheduleOrderModalContent: {
      formContent: {
        orderTypeTitle: 'orderType',
        restaurantTitle: 'YourKFCLocation',
        yourLocationTitle: 'yourLocation',
        editTitle: 'edit',
        scheduleDateTitle: 'scheduleForYourOrder',
        dateTitle: 'date',
        timeTitle: 'time',
        buttonText: 'confirm',
        dateOptions: ['Today', '23/03/2021', '24/03/2021'],
        timeOptions: [9.3, 10.0, 10.3, 11.0],
      },
    },
    DELIVERY_NA_WARNING_MESSAGE: 'noStoresWithDeliveryHeader',
    DELIVERY_PICKUP_NA_MESSAGE: 'deliverystoresWithoutAnyServiceHeader',
    SWITCH_TO_TAKEAWAY: 'switchToTakeaway',
    errorMessageInactive: 'errorMessageInactive',
    errorMessageClosed: 'errorMessageClosed',
  },
  timingsSampleData: {
    operatingHours: [
      {
        day: 'EVERYDAY',
        availableHours: {
          from: '10:00',
          to: '23:00',
        },
      },
    ],
    asap: {
      isAvailable: true,
      promiseTime: 0,
    },
    scheduled: {
      date: '2021-05-05',
      periods: [
        {
          startEndTime: {
            from: '11:30',
            to: '23:00',
          },
          interval: 15,
        },
      ],
      unavailibilities: [],
    },
    futureDates: ['2021-05-06'],
  },
};

export default SCHEDULE_ORDER_SAMPLE_DATA;
